import type { Theme } from '@mui/material/styles';

import { alpha } from '@mui/material/styles';

//
import { StarIcon } from './CustomIcons';

const Rating = (theme: Theme) => {
  return {
    MuiRating: {
      defaultProps: {
        emptyIcon: <StarIcon />,
        icon: <StarIcon />,
      },
      styleOverrides: {
        iconEmpty: {
          color: alpha(theme.palette.grey[500], 0.48),
        },
        root: {
          '&.Mui-disabled': {
            opacity: 0.48,
          },
        },
        sizeLarge: {
          '& svg': {
            height: 28,
            width: 28,
          },
        },
        sizeSmall: {
          '& svg': {
            height: 20,
            width: 20,
          },
        },
      },
    },
  };
};

export default Rating;
